import { UPLOADATTACHMENT_FAIL, UPLOADATTACHMENT_SUCCESS } from '../actionTypes';
const initialState = {
    user: null
};

const uploadAttachmentReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPLOADATTACHMENT_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case UPLOADATTACHMENT_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }
    return state;
};

export default uploadAttachmentReducer;
